import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// İkonları import ettiğinizden emin olun
import EditIcon from './assets/images/edit-icon.svg';
import DeleteIcon from './assets/images/delete-icon.svg';
import PlusIcon from './assets/images/plus-icon.svg';
import MusteriDuzenleModal from './MusteriDuzenleModal';

function MusterilerListesi() {
    // --- STATE'LER (Sayfalama için güncellendi) ---
    const navigate = useNavigate()
    const [musteriler, setMusteriler] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState(""); // Arama için state
    
    // YENİ: Sayfalama için state'ler
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    // YENİ: İl/İlçe filtre state'leri
    const [iller, setIller] = useState([]);
    const [ilceler, setIlceler] = useState([]);
    const [seciliIl, setSeciliIl] = useState("");
    const [seciliIlce, setSeciliIlce] = useState("");

    // Sipariş açılır bant state'leri
    const [expandedMusteriId, setExpandedMusteriId] = useState(null);
    const [musteriSiparisler, setMusteriSiparisler] = useState({});
    const [siparisYukleniyor, setSiparisYukleniyor] = useState(false);

    // Sıralama state'i
    const [siralama, setSiralama] = useState('isim');

    // Modal state'leri
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [seciliMusteri, setSeciliMusteri] = useState(null);
    const [modalMode, setModalMode] = useState('add'); // 'add' veya 'edit'

    // --- FONKSİYONLAR ---

    // Backend'den müşteri listesini çeken ana fonksiyon (sayfa numarası ile)
    const fetchMusteriler = (page = 1, arama = "") => {
        setLoading(true);
            let url = `${process.env.REACT_APP_API_URL}/api/musteriler/tum?page=${page}`;
                if (arama) {
                    url += `&arama=${encodeURIComponent(arama)}`;
            }
 
        fetch(url, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
            .then(response => response.json())
            .then(data => {
                setMusteriler(data.musteriler);
                setTotalPages(data.total_pages);
                setCurrentPage(data.current_page);
            })
            .catch(error => console.error('Müşterileri çekerken hata:', error))
           .finally(() => setLoading(false));
    };
    
    // Müşteri silme fonksiyonu
    const handleMusteriSil = (musteriId) => {
        if (window.confirm(`Emin misiniz? ID'si ${musteriId} olan müşteri kaydı kalıcı olarak silinecektir.`)) {
            fetch(`${process.env.REACT_APP_API_URL}/api/musteriler/${musteriId}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            .then(res => {
                if (!res.ok) {
                    // Sunucudan bir hata mesajı gelirse onu göster
                    return res.json().then(err => { throw new Error(err.hata || 'Silme işlemi başarısız oldu.') });
                }
                return res.json();
            })
            .then(data => {
                alert(data.mesaj);
                // Listeyi mevcut sayfadan yeniden çek
                fetchMusteriler(currentPage); 
            })
            .catch(error => {
                console.error('Müşteri silinirken hata:', error);
                alert(`Hata: ${error.message}`);
            });
        }
    };
    
    // Düzenleme modal'ını açan fonksiyon
    const handleDuzenleClick = (musteri) => {
    setModalMode('edit'); // Modu 'düzenleme' olarak ayarla
    setSeciliMusteri(musteri);
    setIsModalOpen(true);
    };

    const handleYeniMusteriClick = () => {
    setModalMode('add'); // Modu 'yeni ekleme' olarak ayarla
    setSeciliMusteri(null); // Düzenlenecek müşteri yok, form boş olacak
    setIsModalOpen(true);
    };

    const handleSaveMusteri = (musteriData) => {
    let endpoint = `${process.env.REACT_APP_API_URL}/api/musteriler`;
    let method = 'POST';

    // Eğer düzenleme modundaysak, endpoint'i ve metodu güncelle
    if (modalMode === 'edit') {
        endpoint = `${process.env.REACT_APP_API_URL}/api/musteriler/${musteriData.id}`;
        method = 'PUT';
    }

        fetch(endpoint, {
            method: method,
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(musteriData)
        })

        .then(async (res) => {
            const data = await res.json();
            if (!res.ok) {
                throw new Error(data.hata || 'Müşteri kaydı sırasında bir hata oluştu.');
            }
            return data;
        })
        .then(data => {
            alert(data.mesaj);
            setIsModalOpen(false); // Formu kapat
            fetchMusteriler(currentPage, searchTerm); // Listeyi yenile
        })
        
        .catch(error => {
            console.error('Müşteri kaydedilirken hata:', error);
            alert(`Hata: ${error.message}`);
        });
        };

    // --- EFFECT'LER --

    // İl listesini yükle
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/konum/iller`)
            .then(response => response.json())
            .then(data => setIller(data))
            .catch(error => console.error('İl listesi yüklenirken hata:', error));
    }, []);

    // Seçili il değiştiğinde ilçeleri yükle
    useEffect(() => {
        if (seciliIl) {
            fetch(`${process.env.REACT_APP_API_URL}/api/konum/ilceler/${seciliIl}`)
                .then(response => response.json())
                .then(data => setIlceler(data))
                .catch(error => console.error('İlçe listesi yüklenirken hata:', error));
        } else {
            setIlceler([]);
            setSeciliIlce("");
        }
    }, [seciliIl]);

    // Component ilk yüklendiğinde veya sayfa numarası değiştiğinde listeyi çeker
    useEffect(() => {
        // Bu useEffect, arama terimi veya sayfa numarası değiştiğinde tetiklenir.
        const delayDebounceFn = setTimeout(() => {
            setLoading(true);
            
            // URL'i oluştururken hem arama terimini hem de sayfa numarasını ekle
            let url = new URL(`${process.env.REACT_APP_API_URL}/api/musteriler/tum`);
            let params = new URLSearchParams();
            
            // Mevcut sayfayı kullan (arama değiştiğinde handleSearchChange zaten sayfa 1'e ayarlıyor)
            params.append('page', currentPage.toString());
            
            // Arama terimi varsa ekle
            if (searchTerm) {
                params.append('arama', searchTerm);
            }

            // İl filtresi varsa ekle
            if (seciliIl) {
                params.append('il', seciliIl);
            }

            // İlçe filtresi varsa ekle
            if (seciliIlce) {
                params.append('ilce', seciliIlce);
            }

            // Sıralama parametresini ekle
            params.append('siralama', siralama);
            
            url.search = params.toString();
            
            fetch(url.toString(), {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (!data.musteriler) {
                        console.error('Backend yanıtı beklenen formatta değil:', data);
                        throw new Error('Veri formatı hatalı');
                    }
                    setMusteriler(data.musteriler);
                    setTotalPages(data.total_pages);
                    setCurrentPage(data.current_page);
                })
                .catch(error => {
                    console.error('Müşterileri çekerken hata:', error);
                    setMusteriler([]);
                    setTotalPages(1);
                })
                .finally(() => setLoading(false));
        }, 300); // Kullanıcı yazmayı bıraktıktan 300ms sonra isteği gönder

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm, currentPage, seciliIl, seciliIlce, siralama]); // Arama, sayfa, il, ilçe veya sıralama değişince yeniden çalışır

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setCurrentPage(1); // Her yeni aramada ilk sayfadan başla
    };

    const handleIlChange = (e) => {
        const value = e.target.value;
        setSeciliIl(value);
        setSeciliIlce(""); // İl değişince ilçeyi sıfırla
        setCurrentPage(1); // Her yeni filtrede ilk sayfadan başla
    };

    const handleIlceChange = (e) => {
        const value = e.target.value;
        setSeciliIlce(value);
        setCurrentPage(1); // Her yeni filtrede ilk sayfadan başla
    };

    const handleToggleSiparisler = (musteriId) => {
        if (expandedMusteriId === musteriId) {
            setExpandedMusteriId(null);
            return;
        }
        setExpandedMusteriId(musteriId);
        if (musteriSiparisler[musteriId] !== undefined) return;
        setSiparisYukleniyor(true);
        fetch(`${process.env.REACT_APP_API_URL}/api/musteriler/${musteriId}/siparisler`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        })
            .then(r => r.json())
            .then(data => setMusteriSiparisler(prev => ({ ...prev, [musteriId]: data })))
            .catch(() => setMusteriSiparisler(prev => ({ ...prev, [musteriId]: [] })))
            .finally(() => setSiparisYukleniyor(false));
    };

    return (
        <div style={{ background: '#F8F8F8', padding: '20px', borderRadius: '8px', height: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexShrink: 0, gap: '10px' }}>
                <style>{`
                .siparis-satiri {
                    transition: all 0.2s ease-in-out;
                }
                .siparis-satiri:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
                    z-index: 10;
                    position: relative;
                }
                /* Arama inputundaki çarpı işaretini kaldır */
                input[type="search"]::-webkit-search-cancel-button {
                    display: none;
                }
                input[type="search"]::-webkit-search-decoration {
                    display: none;
                }
                input[type="search"] {
                    -webkit-appearance: none;
                }
                `}</style>
                
                {/* Arama ve Filtre Alanları */}
                <div style={{ display: 'flex', gap: '10px', flex: 1 }}>
                    <input 
                        type="text" 
                        placeholder="Ad veya telefona göre ara..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        style={{ padding: '10px', width: '250px', border: '1px solid #ccc', borderRadius: '4px' }}
                    />
                    
                    <select
                        value={seciliIl}
                        onChange={handleIlChange}
                        style={{ padding: '10px', width: '150px', border: '1px solid #ccc', borderRadius: '4px', cursor: 'pointer' }}
                    >
                        <option value="">Tüm İller</option>
                        {iller.map(il => (
                            <option key={il} value={il}>{il}</option>
                        ))}
                    </select>

                    <select
                        value={seciliIlce}
                        onChange={handleIlceChange}
                        disabled={!seciliIl}
                        style={{ 
                            padding: '10px', 
                            width: '150px', 
                            border: '1px solid #ccc', 
                            borderRadius: '4px', 
                            cursor: seciliIl ? 'pointer' : 'not-allowed',
                            opacity: seciliIl ? 1 : 0.6
                        }}
                    >
                        <option value="">Tüm İlçeler</option>
                        {ilceler.map(ilce => (
                            <option key={ilce} value={ilce}>{ilce}</option>
                        ))}
                    </select>
                </div>

                {/* Sıralama butonları */}
                <div style={{ display: 'flex', border: '0.50px solid black', borderRadius: '10px', overflow: 'hidden', height: '32px', boxShadow: '2px 2px 2px rgba(0,0,0,0.10)' }}>
                    <button
                        onClick={() => { setSiralama('isim'); setCurrentPage(1); }}
                        style={{ padding: '0 14px', border: 'none', cursor: 'pointer', fontWeight: '500', fontSize: '13px', background: siralama === 'isim' ? '#272935' : '#F8F8F8', color: siralama === 'isim' ? '#fff' : '#222', transition: 'background 0.15s' }}
                    >
                        İsme Göre
                    </button>
                    <button
                        onClick={() => { setSiralama('siparis'); setCurrentPage(1); }}
                        style={{ padding: '0 14px', border: 'none', borderLeft: '0.50px solid black', cursor: 'pointer', fontWeight: '500', fontSize: '13px', background: siralama === 'siparis' ? '#272935' : '#F8F8F8', color: siralama === 'siparis' ? '#fff' : '#222', transition: 'background 0.15s' }}
                    >
                        Siparişe Göre
                    </button>
                </div>

                <button 
                    onClick={handleYeniMusteriClick}
                    style={{ background: '#F8F8F8', boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.10)', borderRadius: '10px', border: '0.50px black solid', width: '129px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', cursor: 'pointer', fontWeight: '500', marginLeft: '16px' }}
                        >
                        <img src={PlusIcon} alt="Yeni" style={{ height: '14px' }} />
                        <span>Yeni Müşteri</span>
                </button>
            </div>

            <div style={{ flex: 1, overflowY: 'auto', overflowX: 'auto', border: '1px solid #eee', borderRadius: '4px' }}>
            <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, fontSize: '14px' }}>
                <thead>
                    <tr style={{ background: '#E5E5E5', height: '35px' }}>
                        <th style={{ width: '3%', padding: '12px', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}></th>
                        <th style={{ width: '10%', padding: '12px', textAlign: 'left', fontWeight: '500', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Telefon</th>
                        <th style={{ width: '15%', padding: '12px', textAlign: 'left', fontWeight: '500', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Adı Soyadı</th>
                        <th style={{ width: '30%', padding: '12px', textAlign: 'left', fontWeight: '500', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>Adres</th>
                        <th style={{ width: '12%', padding: '12px', textAlign: 'left', fontWeight: '500', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>İl</th>
                        <th style={{ width: '13%', padding: '12px', textAlign: 'left', fontWeight: '500', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>İlçe</th>
                        <th style={{ width: '15%', padding: '12px', textAlign: 'center', fontWeight: '500', position: 'sticky', top: 0, zIndex: 20, background: '#E5E5E5', borderBottom: '1px solid #ddd' }}>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    {loading && <tr><td colSpan="7" style={{textAlign: 'center', padding: '20px'}}>Yükleniyor...</td></tr>}
                    {!loading && musteriler.length === 0 && <tr><td colSpan="7" style={{textAlign: 'center', padding: '20px'}}>Kayıt bulunamadı.</td></tr>}
                    {!loading && musteriler.map((musteri) => (
                        <React.Fragment key={musteri.id}>
                        <tr className="siparis-satiri" style={{ background: '#ffffff', height: '24px', borderBottom: expandedMusteriId === musteri.id ? 'none' : '1px solid #eee' }}>
                            <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                                <button
                                    onClick={() => handleToggleSiparisler(musteri.id)}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '10px', color: '#666', padding: '2px 4px', lineHeight: 1 }}
                                    title="Siparişleri göster/gizle"
                                >
                                    {expandedMusteriId === musteri.id ? '▼' : '▶'}
                                </button>
                            </td>
                            <td style={{ padding: '12px' }}>{musteri.telefon_numarasi}</td>
                            <td style={{ padding: '12px' }}>{musteri.ad_soyad}</td>
                            <td style={{ padding: '12px' }}>{musteri.adres}</td>
                            <td style={{ padding: '12px' }}>{musteri.il || ''}</td>
                            <td style={{ padding: '12px' }}>{musteri.ilce || ''}</td>
                            <td style={{ padding: '12px', textAlign: 'center' }}>
                                <button onClick={() => handleDuzenleClick(musteri)} style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '10px' }}>
                                    <img src={EditIcon} alt="Düzenle" style={{ width: '16px' }} />
                                </button>
                                <button onClick={() => handleMusteriSil(musteri.id)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                    <img src={DeleteIcon} alt="Sil" style={{ width: '16px' }} />
                                </button>
                            </td>
                        </tr>
                        {expandedMusteriId === musteri.id && (
                            <tr style={{ background: '#f9f9f9', borderBottom: '1px solid #eee' }}>
                                <td colSpan="7" style={{ padding: '0 12px 10px 40px' }}>
                                    {siparisYukleniyor && !musteriSiparisler[musteri.id] ? (
                                        <span style={{ fontSize: '12px', color: '#888' }}>Yükleniyor...</span>
                                    ) : musteriSiparisler[musteri.id]?.length === 0 ? (
                                        <span style={{ fontSize: '12px', color: '#888' }}>Bu müşteriye ait sipariş bulunamadı.</span>
                                    ) : (
                                        <table style={{ borderCollapse: 'collapse', fontSize: '12px', width: 'auto' }}>
                                            <thead>
                                                <tr style={{ color: '#555' }}>
                                                    <th style={{ padding: '4px 16px 4px 0', fontWeight: '600', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Sipariş No</th>
                                                    <th style={{ padding: '4px 16px 4px 0', fontWeight: '600', textAlign: 'left', borderBottom: '1px solid #ddd' }}>Tarih</th>
                                                    <th style={{ padding: '4px 0', fontWeight: '600', textAlign: 'right', borderBottom: '1px solid #ddd' }}>Tutar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(musteriSiparisler[musteri.id] || []).map(s => (
                                                    <tr key={s.id}>
                                                        <td style={{ padding: '3px 16px 3px 0', color: '#333' }}>{s.siparis_no}</td>
                                                        <td style={{ padding: '3px 16px 3px 0', color: '#333' }}>{s.siparis_tarihi}</td>
                                                        <td style={{ padding: '3px 0', color: '#333', textAlign: 'right' }}>{s.toplam_bedel.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </td>
                            </tr>
                        )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>
            </div>

            {/* --- YENİ: SAYFALAMA KONTROLLERİ --- */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', gap: '10px', flexShrink: 0 }}>
                <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
                    İlk Sayfa
                </button>
                <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}>
                    &lt; Önceki
                </button>
                <span>
                    Sayfa <strong>{currentPage}</strong> / {totalPages}
                </span>
                <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}>
                    Sonraki &gt;
                </button>
                <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}>
                    Son Sayfa
                </button>
            </div>

            <MusteriDuzenleModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                musteri={seciliMusteri}
                onSave={handleSaveMusteri}
            />
        </div>
    );
}

export default MusterilerListesi;